import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const commentaryActivityFeatureKey = 'commentaryActivity'

export interface CommentaryActivityRedux {
  accountId: string | null
  count: number
  openAssigned: number
  tagged: number
  loading: boolean
  error: string | null
}

export const commentaryActivityInitialState: CommentaryActivityRedux = {
  accountId: null,
  count: 0,
  openAssigned: 0,
  tagged: 0,
  loading: false,
  error: null,
}

export const commentaryActivitySlice = createSlice({
  name: commentaryActivityFeatureKey,
  initialState: commentaryActivityInitialState,
  reducers: {
    loadCommentaryActivity: (
      state,
      action: PayloadAction<{ accountId: string }>,
    ) => {
      state.loading = true
      state.error = null
      state.accountId = action.payload.accountId
      // Keep previous count to avoid a flash of "0" while reloading.
    },
    commentaryActivityLoaded: (
      state,
      action: PayloadAction<{
        accountId: string
        count: number
        openAssigned: number
        tagged: number
      }>,
    ) => {
      if (state.accountId !== action.payload.accountId) return
      state.count = action.payload.count
      state.openAssigned = action.payload.openAssigned
      state.tagged = action.payload.tagged
      state.loading = false
      state.error = null
    },
    commentaryActivityLoadFailed: (
      state,
      action: PayloadAction<{ accountId: string; error: string }>,
    ) => {
      if (state.accountId !== action.payload.accountId) return
      state.loading = false
      state.error = action.payload.error
    },
    clearCommentaryActivity: state => {
      state.accountId = null
      state.count = 0
      state.openAssigned = 0
      state.tagged = 0
      state.loading = false
      state.error = null
    },
  },
})

export const {
  loadCommentaryActivity,
  commentaryActivityLoaded,
  commentaryActivityLoadFailed,
  clearCommentaryActivity,
} = commentaryActivitySlice.actions

export const commentaryActivityReducer = commentaryActivitySlice.reducer
